// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d33ceda7","667":"67a7ef98","977":"37501b45"}[chunkId] + ".chunk.js";
};